// These requirements align with the requirements of the configurator
// and should be updated if the configurator requirements change
// screens/configurator/index.tsx
const alwaysRequiredArgs = ["style", "type", "substyle"]
const ringsRequiredArgs = ["stone", "base", "frame", "size"]
const earringsRequiredArgs = ["stone", "base"]

export function productHasRequiredArgsForConfigurator(
  args: any,
  uid: "ring" | "earring"
) {
  const requiredArgs = [...alwaysRequiredArgs]

  if (uid === "ring") {
    requiredArgs.push(...ringsRequiredArgs)
  }

  if (uid === "earring") {
    requiredArgs.push(...earringsRequiredArgs)
  }

  return requiredArgs.every((arg) => args[arg])
}
